import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";

export const ACR_SUMMARY = FORM_FIELDS.EMPLOYEE.ACR_SUMMARY;
export const BASIC_INFO = ACR_SUMMARY.BASIC_INFO;
export const ADD_CONFIDENTIAL_REPORT = ACR_SUMMARY.ADD_CONFIDENTIAL_REPORT;

export const acrValidation = yup.object().shape({
  [BASIC_INFO.GRADATION_NO]: yup.string().required("Gradation No. is required"),
  [BASIC_INFO.RESULT_OF_DIVISIONAL_EXAM]: yup
    .boolean()
    .required("Result of Divisional Exam is required"),
  [BASIC_INFO.WHETHER_ABOVE_50_YEARS_APPLIED_WITHOUT_EXAMINATION_FOR_PROMOTION]:
    yup
      .boolean()
      .required(
        "Whether above 50 years applied without examination for promotion is required",
      ),
  [ADD_CONFIDENTIAL_REPORT.YEAR]: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .nullable()
    .required("Year is required")
    .typeError("Year has to be a number")
    .integer("Year cannot have decimal values")
    .positive("Year cannot be negative")
    .max(9999, "No longer than 4 character"),
  [ADD_CONFIDENTIAL_REPORT.YEAR_BASED_OBTAINED_NUMBER_OF_ACR]: yup
    .number()
    .min(0, "Year based obtained number of ACR has to be 0 - 100")
    .max(100, "Year based obtained number of ACR has to be 0 - 100")
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .nullable()
    .required("Year based obtained number of ACR is required")
    .typeError("Year based obtained number of ACR has to be a number"),
  [ADD_CONFIDENTIAL_REPORT.UPLOAD_ACR]: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.number(),
        name: yup.string(),
        mimeType: yup.string(),
        fileId: yup.string(),
        documentId: yup.string(),
        documentType: yup.string(),
      }),
    )
    .nullable()
    .required("ACR document is required"),
});

export type AcrFormDataType = yup.InferType<typeof acrValidation>;
